import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Box } from '../../components/Box/index.js';
/**
 * The most common white space on screen is between elements stacked
 * vertically. For this use case, we provide a Stack component that
 * accepts a ‘space’ prop.
 */
export const Stack = /*#__PURE__*/_styled(({
  children,
  space = 0,
  align,
  ...restProps
}) => {
  return _jsx(Box, {
    display: "flex",
    flexDirection: "column",
    gap: space,
    alignItems: align,
    textAlign: align,
    ...restProps,
    children: children
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1dds53h0"
} : {
  target: "e1dds53h0",
  label: "Stack"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YWNrLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVHIiwiZmlsZSI6IlN0YWNrLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJveCB9IGZyb20gJy4uLy4uL2NvbXBvbmVudHMvQm94L2luZGV4LmpzJztcbi8qKlxuICogVGhlIG1vc3QgY29tbW9uIHdoaXRlIHNwYWNlIG9uIHNjcmVlbiBpcyBiZXR3ZWVuIGVsZW1lbnRzIHN0YWNrZWRcbiAqIHZlcnRpY2FsbHkuIEZvciB0aGlzIHVzZSBjYXNlLCB3ZSBwcm92aWRlIGEgU3RhY2sgY29tcG9uZW50IHRoYXRcbiAqIGFjY2VwdHMgYSDigJhzcGFjZeKAmSBwcm9wLlxuICovXG5leHBvcnQgY29uc3QgU3RhY2sgPSBzdHlsZWQoKHsgY2hpbGRyZW4sIHNwYWNlID0gMCwgYWxpZ24sIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4KEJveCwgeyBkaXNwbGF5OiBcImZsZXhcIiwgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIiwgZ2FwOiBzcGFjZSwgYWxpZ25JdGVtczogYWxpZ24sIHRleHRBbGlnbjogYWxpZ24sIC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IGNoaWxkcmVuIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9U3RhY2suanMubWFwIl19 */");